import type { SegmentLengthM } from "./types";

// The width of a door or window: the distance between its two jamb points.
export const segmentLengthM: SegmentLengthM = ({
  points,
  metersPerPdfPoint,
}) => {
  if (points.length !== 2 || metersPerPdfPoint <= 0) return null;
  const [start, end] = points;
  return Math.hypot(end.x - start.x, end.y - start.y) * metersPerPdfPoint;
};
